import { assignNamespace } from "@gr-common/head/namespace-utils";
import { o_util } from "@gr-common/head/namespaces";
import { defineStore } from "@gr-common/head/nexus";
import * as mappers from "./mappers.js";
import * as asyncMappers from "./asyncMappers.js";
import { fetchOnexData, transformAndAssignOnexData } from "./fragment.js";

export * from "./mappers.js";

assignNamespace(o_util, "onex", {
  isOnexGroup: mappers.isOnexVariant,
  mapOnexGroup: mappers.mapOnexVariant,
  isOnexVariant: mappers.isOnexVariant,
  mapOnexVariant: mappers.mapOnexVariant,
  withOnex: mappers.withOnex,
  customAssignments: mappers.customAssignments,
});

otto.onex.assignNamespace(
  {
    assignments: defineStore(transformAndAssignOnexData()),
    getAssignments: asyncMappers.getAssignments,
    isOnexVariant: asyncMappers.isOnexVariant,
    mapOnexVariant: asyncMappers.mapOnexVariant,
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);

/*                                                                  */
if (import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true") fetchOnexData();
